'use client'

import { usePathname } from 'next/navigation'

import { useCartActions } from './use-cart-actions'
import { useCartData } from './use-cart-data'
import { useCartItemsData } from './use-cart-items-data'

export const useCart = () => {
	const pathname = usePathname()
	const isCartPage = pathname === '/cart' || pathname === '/cart/'

	const cartPageData = useCartData()
	const cartItemsData = useCartItemsData()

	const { products, cartCount, getBasketItem, refetch, isFetching, isLoading } = isCartPage
		? cartPageData
		: cartItemsData

	const actions = useCartActions({
		products,
		refetch
	})

	return {
		products,
		cartCount,
		getBasketItem,
		isFetching,
		isLoading,

		...(isCartPage && {
			price: cartPageData.price,
			basePrice: cartPageData.basePrice,
			visibleProducts: cartPageData.visibleProducts,
			serviceCount: cartPageData.serviceCount,
			discountList: cartPageData.discountList,
			bonusPay: cartPageData.bonusPay,
			bonusFromOrder: cartPageData.bonusFromOrder,
			showOrderButton: cartPageData.showOrderButton,
			isInit: cartPageData.isInit
		}),

		...actions
	}
}
